import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=75c81e4f&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=75c81e4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c81e4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c81e4f')) {
      api.createRecord('75c81e4f', component.options)
    } else {
      api.reload('75c81e4f', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=75c81e4f&scoped=true&", function () {
      api.rerender('75c81e4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25sdy7AQ8rsNt/JS/comp/CookieBox.vue"
export default component.exports